import getSearchConfig from './functions/get-search-config'
import Search from './views/VSearch.vue'

export default () => {
  const route = getSearchConfig().route
  return [
    {
      path: '/',
      redirect: { name: 'search' }
    },
    {
      path: `/${route}/:topic?`,
      name: 'search',
      component: Search,
      props: route => ({ topicSlug: route.params.topic })
    }
  ]
}
